export default __webpack_public_path__ + "static/media/scratch13.3734db97.mp3";